import { Type } from "@scalar/typebox";
import { compose } from "../schemas/compose.js";
const NavigationBaseSchema = Type.Object({
  type: Type.Union([
    Type.Literal("text"),
    Type.Literal("operation"),
    Type.Literal("model"),
    Type.Literal("tag"),
    Type.Literal("webhook")
  ]),
  id: Type.String(),
  title: Type.String()
});
const TraversedDescriptionSchema = compose(
  NavigationBaseSchema,
  Type.Object({
    type: Type.Literal("text"),
    children: Type.Optional(Type.Array(NavigationBaseSchema))
  })
);
const TraversedOperationSchema = compose(
  NavigationBaseSchema,
  Type.Object({
    type: Type.Literal("operation"),
    ref: Type.String(),
    method: Type.String(),
    path: Type.String()
  })
);
const TraversedSchemaSchema = compose(
  NavigationBaseSchema,
  Type.Object({
    type: Type.Literal("model"),
    ref: Type.String(),
    name: Type.String()
  })
);
const TraversedWebhookSchema = compose(
  NavigationBaseSchema,
  Type.Object({
    type: Type.Literal("webhook"),
    ref: Type.String(),
    method: Type.String(),
    name: Type.String()
  })
);
const TraversedEntryRef = Type.Ref("TraversedEntrySchema");
const TraversedTagRef = Type.Ref("TraversedTagSchema");
const TraversedTagSchemaDefinition = compose(
  NavigationBaseSchema,
  Type.Object({
    type: Type.Literal("tag"),
    name: Type.String(),
    children: Type.Optional(Type.Array(TraversedEntryRef)),
    isGroup: Type.Boolean()
  })
);
const TraversedEntrySchemaDefinition = Type.Union([
  TraversedTagRef,
  TraversedDescriptionSchema,
  TraversedOperationSchema,
  TraversedSchemaSchema,
  TraversedWebhookSchema
]);
const module = Type.Module({
  TraversedTagSchema: TraversedTagSchemaDefinition,
  TraversedEntrySchema: TraversedEntrySchemaDefinition
});
const TraversedTagSchema = module.Import("TraversedTagSchema");
const TraversedEntrySchema = module.Import("TraversedEntrySchema");
export {
  NavigationBaseSchema,
  TraversedDescriptionSchema,
  TraversedEntrySchema,
  TraversedOperationSchema,
  TraversedSchemaSchema,
  TraversedTagSchema,
  TraversedWebhookSchema
};
//# sourceMappingURL=navigation.js.map
